const monthlySampleDates = (): Date[] => [new Date()];
export default monthlySampleDates;
